import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Flex, Heading } from '@chakra-ui/react';
import { ChevronRightIcon } from '@assets/icons';
import { tableList } from './const';
import TableTemplate2 from '@components/tableTemplate2';
import { EmptyStateSelloutImage } from '@assets/images';
import { useGetHistory } from '@pages/UploadSellout/hooks/query/useGetHistory';

const History = () => {
    const navigate = useNavigate();
    const [sortType, setSortType] = useState();
    const { data, isLoading } = useGetHistory({ sortType });

    const handleSort = (value) => {
        const isSameField = sortType?.name === value;
        const nextType = isSameField && sortType.type === 'desc' ? 'asc' : 'desc';
        setSortType({ name: value, type: nextType });
    };

    return (
        <Box id="history__upload-sellout">
            <Flex mb={'24px'} justifyContent={'space-between'}>
                <Heading fontWeight={'600'} fontSize={'20px'} mb={'8px'}>
                    Riwayat
                </Heading>

                <Button variant={'unstyled'} onClick={() => navigate('/audit-trail/sell-out')} fontWeight={'700'}>
                    Lihat Semua Riwayat
                    <ChevronRightIcon fill="#215aa8" />
                </Button>
            </Flex>

            <TableTemplate2
                data={data}
                tableList={tableList}
                isLoading={isLoading}
                initialStateImage={<EmptyStateSelloutImage />}
                description="Saat ini, data product belum tersedia."
                sortType={sortType}
                onSort={handleSort}
            />
        </Box>
    );
};

export default History;
